<script lang="ts">
  import {
    AlignHorizontalLeft,
    AlignHorizontalRight,
    TextAlignCenter,
    TextAlignLeft,
    TextAlignRight,
    TextBold,
    TextItalic,
    TextUnderline,
  } from "carbon-icons-svelte";
  export let value: string;
  export let size: 16 | 20 | 24 | 32 = 16;
  value = value.toLowerCase();
</script>

<!-- alignment -->
{#if value === "left margin"}
  <AlignHorizontalLeft {size} />
{/if}
{#if value === "left"}
  <TextAlignLeft {size} />
{/if}
{#if value === "center"}
  <TextAlignCenter {size} />
{/if}
{#if value === "right"}
  <TextAlignRight {size} />
{/if}
{#if value === "right margin"}
  <AlignHorizontalRight {size} />
{/if}
<!-- style -->
{#if value === "bold"}
  <TextBold {size} />
{/if}
{#if value === "italic"}
  <TextItalic {size} />
{/if}
{#if value === "underline"}
  <TextUnderline {size} />
{/if}
